__turbopack_context__.v({
  "button": "DRdskq_button",
  "noImage": "DRdskq_noImage",
  "thumbnail": "DRdskq_thumbnail",
  "wrapper": "DRdskq_wrapper",
});
